// Vendors
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useErrorBoundary } from 'react-error-boundary';
// Handlers
import { SessionExpireHandlers } from '../handlers/session-expire.handlers';
// Types
import { SessionExpireHookType } from './types/session-expire.hook.type';

const useSessionExpireHook = (): SessionExpireHookType => {
  const [sessionWarningMessage, setSessionWarningMessage] = useState('');

  const { formatMessage } = useIntl(),
    { showBoundary: setError } = useErrorBoundary();

  const timeoutRef = useRef(0);

  const { handleCloseWarningMessage, handleStartSessionTimeout } = SessionExpireHandlers({
    formatMessage,
    timeoutRef,
    setError,
    setSessionWarningMessage,
  });

  useEffect(() => {
    handleStartSessionTimeout();
  }, []);

  return {
    handleCloseWarningMessage,
    sessionWarningMessage,
    openSnackbar: sessionWarningMessage !== '',
  };
};

export { useSessionExpireHook };
